import { ButtonVariantsEnum } from '@arthur/ui'
import PopIn from '@components/layout/PopIn'
import { Typography } from '@mui/material'
import { useIntl } from 'react-intl'

type DialogProps = {
	cancelLabel?: string
	confirmLabel?: string
	isOpen: boolean
	message: string
	onCancel?: () => void
	onClose: () => void
	onConfirm?: () => void
	title: string
}

/**
 * Dialog
 * @param cancelLabel
 * @param confirmLabel
 * @param isOpen
 * @param message
 * @param onCancel
 * @param onClose
 * @param onConfirm
 * @param title
 * @constructor
 */
const Dialog = (
	{
		cancelLabel,
		confirmLabel,
		isOpen,
		message,
		onCancel,
		onClose,
		onConfirm,
		title
	}: DialogProps
) => {
	const { formatMessage } = useIntl()

	return (
		<PopIn
			buttons={[
				...(
					onConfirm
						? [{
							label: confirmLabel || formatMessage({ id: 'global.buttons.confirm' }),
							onClick: () => onConfirm()
						}]
						: []
				),
				...(
					onCancel
						? [{
							label: cancelLabel || formatMessage({ id: 'global.buttons.cancel' }),
							onClick: () => onCancel(),
							variant: ButtonVariantsEnum.tertiary
						}]
						: []
				)
			]}
			isOpen={isOpen}
			onClose={onClose}
			title={title}
		>
			<Typography>
				{message}
			</Typography>
		</PopIn>
	)
}

export default Dialog
